import React, { useState } from "react"
import Modal from "react-bootstrap/Modal"
import { Delete, Subtract, Add } from "../../HemeIconLibrary"

const Index = ({ changeQuantity, data, deleteIcon, cta, border }) => {
  // Modal
  const [show, setShow] = useState(false)
  return (
    <>
      <div
        className={`flex items-center justify-between gap-[10px] p-[5px] ${
          border ? "" : "border"
        } border-solid  boder-[#DEE2ED] rounded-full item-count-value`}
      >
        <button
          onClick={() => {
            changeQuantity(data, data?.count === 1 ? 1 : data?.count - 1)
            if (cta) {
              const getCartItemsFromLocal = localStorage
                .getItem("cart-item-ids")
                ?.split(",")

              const index = getCartItemsFromLocal?.indexOf(String(data.id))

              console.log(index, getCartItemsFromLocal, String(data.id))
              if (index === -1) {
                localStorage.setItem("cart-item-ids", [
                  ...getCartItemsFromLocal,
                  data.id,
                ])
              } else {
                getCartItemsFromLocal?.splice(index, 1)
                localStorage.setItem("cart-item-ids", getCartItemsFromLocal)
              }
            }
          }}
          className={`w-[33px] h-[33px] rounded-full ${
            (data?.count === 1 || isNaN(data?.count) || data?.count === 0) &&
            !deleteIcon &&
            "opacity-30"
          } flex items-center justify-center bg-qtyBg`}
          disabled={
            (data?.count === 1 || isNaN(data?.count) || data?.count === 0) &&
            !deleteIcon
              ? true
              : false
          }
        >
          {data?.count > 1 ? (
            <Subtract />
          ) : deleteIcon ? (
            <div
              onClick={() => {
                setShow(true)
              }}
            >
              <Delete color="#F87FB1" />
            </div>
          ) : (
            <Subtract />
          )}
        </button>

        {/* <span classsName="text-sm font-bold leading-4 text-primary1">{data?.count || 1}</span> */}
        <input
          type="number"
          min="1"
          max="999"
          value={data?.count}
          className="text-sm font-bold leading-4 w-[27px] text-primary1 border-none outline-none"
          onChange={(e) => {
            const qty = parseInt(e.target.value)
            console.log("e", qty)
            if (qty <= 999 || isNaN(qty)) {
              changeQuantity(data, qty)
            }
          }}
          // onKeyDown={(event) => {
          //   if (event.keyCode === 48 || event.keyCode === 96) {
          //     event.preventDefault(); // Prevent the default behavior (inserting "0")
          //     event.target.value = 1; // Replace the input value with 1
          //     changeQuantity(data, 1);
          //   }
          // }}
          onke
        />
        <button
          onClick={() => {
            changeQuantity(
              data,
              data?.count ? (data.count === 1 ? 2 : data?.count + 1) : 1
            )
            if (cta) {
              cta(data, true)
            }
          }}
          className={`w-[33px] h-[33px] rounded-full ${
            data?.count === 999 && "opacity-30"
          } flex items-center justify-center bg-qtyBg`}
          disabled={data?.count === 999 ? true : false}
        >
          <Add color="#605DAF" />
        </button>
      </div>
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={() => setShow(false)}
        animation={false}
      >
        <Modal.Body>
          <p className="m-0 text-base font-semibold text-center">
            Are you sure, you want to Remove?
          </p>
        </Modal.Body>

        <Modal.Footer>
          <div className="flex gap-[20px]  items-center justify-center w-full">
            <p
              className="m-0 text-base font-semibold cursor-pointer user-down-item"
              href=""
              onClick={() => {
                if (cta) {
                  cta(data, false)
                }
              }}
            >
              Yes
            </p>
            <p
              className="m-0 text-base font-semibold cursor-pointer user-down-item"
              href=""
              onClick={() => setShow(false)}
            >
              No
            </p>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default Index
